<template>
  <div id="mainBody">
    <div class="bg-fx" aria-hidden="true">
      <span class="blob blob-1"></span>
      <span class="blob blob-2"></span>
      <span class="blob blob-3"></span>
      <span class="ring r1"></span>
      <span class="ring r2"></span>
      <span class="ring r3"></span>
      <span class="spark s1"></span>
      <span class="spark s2"></span>
      <span class="spark s3"></span>
      <span class="spark s4"></span>
      <span class="spark s5"></span>
      <span class="spark s6"></span>
    </div>

    <div class="content" id="mainUI">
      <div class="phone-holder" style="animation: 2s ease-in-out 0s infinite normal none running dynamicShakeSoft;">
        <img :src="baseUrl + 'img/text-bubble.png'" alt="Notification" class="bubble-img is-visible" id="bubbleImg">
        <img :src="baseUrl + 'img/phone.png'" alt="Phone" class="phone-img is-visible" id="phoneImg">
      </div>
      <div class="status-text" id="statusLabel" style="opacity: 1;"></div>
      <div class="status-text-dua" id="statusLabelDua" style="opacity: 1;"></div>
    </div>
  </div>
</template>

<script>
import { Api } from '@/services';
import { useHead } from '@vueuse/head'

export default {
  name: 'WaitingPage',
  setup() {
    useHead({
      link: [
        { rel: 'preconnect', href: 'https://fonts.googleapis.com' },
        { rel: 'preconnect', href: 'https://fonts.gstatic.com', crossorigin: '' },
        {
          rel: 'stylesheet',
          href: 'https://fonts.googleapis.com/css2?family=Bangers&display=swap'
        },
        {
          rel: 'stylesheet',
          href: `${process.env.BASE_URL}css/waitingchat.css`
        }
      ]
    })
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      subsId: '',
      redirectURL: "https://sinyalhati.com/player?utm_source=internal&utm_medium=fallback_redirect&utm_campaign=kjw_acquisition&utm_content=lupa_kode_kupon&hashid=",
      urlFallback: "https://sinyalhati.com/idw"
    };
  },
  mounted() {
    this.subsId = this.$route.params.sid
    this.ready();
    if (this.subsId == "") {
      window.location.href = this.urlFallback;
    }
  },
  methods: {
    ready() {
      var self = this;
      document.addEventListener('DOMContentLoaded', function () {
        const phoneHolder = document.querySelector('.phone-holder');
        const phoneImg = document.getElementById('phoneImg');
        const bubbleImg = document.getElementById('bubbleImg');
        const statusLabel = document.getElementById('statusLabel');
        const statusLabelDua = document.getElementById('statusLabelDua');
        const text = 'Sebentar ...';
        const secondText = 'Ada Pesan Masuk ...';
        let charIndex = 0;
        let secondCharIndex = 0;
        const phonePopDelay = 100;
        const phonePopDuration = 620;
        const strongShakeDuration = 900;
        const bubblePopDuration = 480;

        setTimeout(() => {
          phoneImg.classList.add('is-visible');
        }, phonePopDelay);

        setTimeout(() => {
          phoneHolder.style.animation = 'dynamicShake 0.45s infinite linear';
        }, phonePopDelay + phonePopDuration);

        setTimeout(() => {
          phoneHolder.style.animation = 'dynamicShakeSoft 2s infinite ease-in-out';
          bubbleImg.classList.add('is-visible');
        }, phonePopDelay + phonePopDuration + strongShakeDuration);

        function typeText() {
          if (charIndex < text.length) {
            statusLabel.textContent += text.charAt(charIndex);
            charIndex++;
            setTimeout(typeText, 100); // Adjust speed here
          } else {
            setTimeout(() => {
              statusLabelDua.style.opacity = '1';
              typeSecondText();
            }, 1000);
          }
        }

        function typeSecondText() {
          if (secondCharIndex < secondText.length) {
            statusLabelDua.textContent += secondText.charAt(secondCharIndex);
            secondCharIndex++;
            setTimeout(typeSecondText, 100);
          } else {
            self.writeLog(self.subsId);
          }
        }

        setTimeout(() => {
          statusLabel.style.opacity = '1';
          typeText();
        }, phonePopDelay + phonePopDuration + strongShakeDuration + bubblePopDuration);
      });
    },
    writeLog(id) {
      var self = this;
      var r = this.redirectURL + id
      Api.writeWaitingLog(id, r)
        .then(() => {
          self.showSuccess(r)
        })
    },
    showSuccess(url) {
      setTimeout(() => {
        window.location.href = url;
      }, 2000);
    },
  }
}
</script>
